module.exports = __webpack_public_path__ + "img/cross-light.b337dde8.svg";